import { warningAlert } from 'pages/components/SweetAlert';
import React, { useState } from 'react'
import { Button, Input, InputGroup, InputGroupAddon } from 'reactstrap';


export default function BuscadorTiposMateriales(props){
    const {setObjetos, getObjetos, setBuscar,query, setQuery} = props
    
    const [Alert, setAlert] = useState(null)

    const cambiarQuery = event => {
        setQuery(event.target.value);
      };
    
    const Buscar = async()=>{
    let params = {query_result:query,page:1, limit:5}
    let result = await getObjetos(params)
    if(result != null){
        setObjetos(result.tiposMateriales);
        if (setBuscar) {
            setBuscar(true)
        }
    }else{warningAlert(setAlert,"No se pudo buscar");}
    }


    const keyDownFunction =(event) => {
        if (event.keyCode === 13) {
            Buscar();
        }
      }
    

    return(
        <InputGroup>
        {Alert}
        <Input placeholder="Buscar" type="text" 
            value={query} 
            onChange={cambiarQuery}
            onKeyDown={(e)=>keyDownFunction(e)}
        />
        {query?
            <Button className="ml-3" color="success" outline type="button" onClick={()=>Buscar()}>
            Buscar
            </Button>
        :
            <></>
        }

        </InputGroup>
    )
}